import * as React from 'react'
import styles from './ProductDropdown.module.scss'
import { CustomTagProps } from '../../FilterGroup.types'

/**
 * Multi-select Tag Element
 *
 * @returns {React.ReactElement}
 */
const Tag: React.FC<CustomTagProps> = ({ label, onClose }: CustomTagProps): React.ReactElement => {
  return (
    <div className={styles.tag}>
      <span aria-hidden={true} onClick={onClose} className={styles.closeTag}>
        x
      </span>
      <span className={styles.tagLabel}>{label}</span>
    </div>
  )
}

export default Tag
